import React from "react";

const CustomNumberInput = ({ value, onChange, ...props }) => {
  const handleWheel = (e) => {
    e.target.blur(); // prevent scroll-to-increment
  };

  const handleKeyDown = (e) => {
    // Block scientific notation and sign keys
    if (["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
    // Allow control keys (backspace, delete, arrows, etc.)
    if (
      ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter"]
        .includes(e.key)
    ) {
      return;
    }
    // Optional: allow only digits and dot
    if (!/[\d.]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleChange = (e) => {
    let inputValue = e.target.value;

    // Allow empty
    if (inputValue === "") {
      onChange("");
      return;
    }

    // Allow only digits and at most one dot
    if (/^\d*\.?\d*$/.test(inputValue)) {
      // Prevent saving incomplete decimals like "." or "55."
      if (inputValue === "." || inputValue.endsWith(".")) {
        // Still allow user to type "55." temporarily while typing "55.75"
        onChange(inputValue);
        return;
      }

      // If it's a valid number string, pass it
      const num = parseFloat(inputValue);
      if (!isNaN(num)) {
        // Keep original string format (don't auto-convert to number)
        onChange(inputValue);
      } else {
        // Fallback: don't update if invalid
        return;
      }
    }
  };

  return (
    <input
      type="text"
      inputMode="decimal" 
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onWheel={handleWheel}
      className="form-control"
      {...props}
    />
  );
};

export default CustomNumberInput;